import { render, staticRenderFns } from "./VehicleWork.vue?vue&type=template&id=2a78befa&lang=pug&"
import script from "./VehicleWork.vue?vue&type=script&lang=ts&"
export * from "./VehicleWork.vue?vue&type=script&lang=ts&"
import style0 from "./VehicleWork.vue?vue&type=style&index=0&id=2a78befa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports